import phy_day_one_1280 from '../img/purchase/physical_day_one_1280.jpg';
import phy_day_one_1280_webp from '../img/purchase/physical_day_one_1280.webp';
import phy_day_one_640 from '../img/purchase/physical_day_one_640.jpg';
import phy_day_one_640_webp from '../img/purchase/physical_day_one_640.webp';
import dde_1280 from '../img/purchase/digital_deluxe_1280.jpg';
import dde_1280_webp from '../img/purchase/digital_deluxe_1280.webp';
import dde_640 from '../img/purchase/digital_deluxe_640.jpg';
import dde_640_webp from '../img/purchase/digital_deluxe_640.webp';
import logo from '../img/hero/logo_lg.png';

export const countryList = [
  {
    country_name: 'United States of America',
    country_id: 'usa',
    country_cookie: 'en',
  },
  {
    country_name: 'Canada',
    country_id: 'ca',
    country_cookie: 'ca',
  },
];

// NOTE: edition_id MUST include digital or physical in it.
export const editionsList = {
  en: [
    {
      edition_name: 'Physical Day One Edition',
      edition_id: 'physicalLaunch',
    },
    {
      edition_name: 'Digital Deluxe Edition',
      edition_id: 'digitalDeluxe',
    },
    {
      edition_name: 'Digital Standard Edition',
      edition_id: 'digitalStandard',
    },
  ],
  ca: [
    {
      edition_name: 'Physical Day One Edition',
      edition_id: 'physicalLaunch',
    },
    {
      edition_name: 'Digital Deluxe Edition',
      edition_id: 'digitalDeluxe',
    },
    {
      edition_name: 'Digital Standard Edition',
      edition_id: 'digitalStandard',
    },
  ],
};

export const platformsList = [
  {
    platform_name: 'Nintendo Switch',
    platform_name_digital: 'Nintendo Switch',
    platform_id: 'switch',
    platform_cookie: 'switch',
    digitalOnly: false,
  },
  {
    platform_name: 'PlayStation&reg;5',
    platform_name_digital: 'PlayStation&reg;5 (Wishlist Only)',
    platform_id: 'ps5',
    platform_cookie: 'ps5',
    digitalOnly: false,
  },
  {
    platform_name: 'Steam',
    platform_name_digital: 'Steam (Wishlist Only)',
    platform_id: 'steam',
    platform_cookie: 'steam',
    digitalOnly: true,
  },
];

export const purchaseLinks = {
  en: {
    ps5: {
      digital: {
        digitalDeluxe: 'https://store.playstation.com/en-us/concept/10009622',
        digitalStandard: 'https://store.playstation.com/en-us/concept/10009622',
      },
      physical: [
        {
          name: 'Marvelous-USA Store',
          link: 'https://www.xseedgames.com/product/farmagia-day-one-edition/',
        },
        {
          name: 'Best Buy',
          link: 'https://www.bestbuy.com/site/farmagia-day-1-edition-playstation-5/6587831.p?skuId=6587831',
        },
        {
          name: 'Amazon',
          link: 'https://www.amazon.com/Farmagia-Day-1-PS5-PlayStation-5/dp/B0D7G2L8CK/ref=sr_1_3?crid=3QO6YFT4T8CHD&dib=eyJ2IjoiMSJ9.ebCd31Hn_oJS4T6_wgc0UHvAyWMthteqKGDVFYu__0U.ywgpaf2r8k65OhBQB4SiwOjqZ4N2fLA-Y62IAtt4qMg&dib_tag=se&keywords=farmagia+game&qid=1719251787&sprefix=farmagia,aps,269&sr=8-3',
        },
        {
          name: 'GameStop',
          link: 'https://www.gamestop.com/video-games/products/farmagia---day-1-edition/20014031.html',
        },
        {
          name: 'Target',
          link: 'https://www.target.com/p/farmagia-day-1-edition-playstation-5/-/A-92542505#lnk=sametab',
        },
        {
          name: 'Walmart',
          link: 'https://www.walmart.com/ip/Farmagia-PlayStation-5/7008261882?from=/search',
        },
      ],
    },
    switch: {
      digital: {
        digitalStandard:
          'https://www.nintendo.com/us/store/products/farmagia-switch/',
        digitalDeluxe:
          'https://www.nintendo.com/us/store/products/farmagia-digital-deluxe-edition-switch/',
      },
      physical: [
        {
          name: 'Marvelous-USA Store',
          link: 'https://www.xseedgames.com/product/farmagia-day-one-edition/',
        },
        {
          name: 'Best Buy',
          link: 'https://www.bestbuy.com/site/farmagia-day-1-edition-nintendo-switch/6587830.p?skuId=6587830',
        },
        {
          name: 'Amazon',
          link: 'https://www.amazon.com/Farmagia-Day-1-Nintendo-Switch/dp/B0D7K44TVF/ref=sr_1_1?crid=UT5PUXZQHJ0P&dib=eyJ2IjoiMSJ9.EJwJhmAPVouLwqn_eTcIRcjiEYmsxczxZJM41inUtU3GjHj071QN20LucGBJIEps.dr7R3GLT_SUoG3Rq45Zjd1s3DIHG0h9rg9Mt6m02CS8&dib_tag=se&keywords=farmagia+game&qid=1719501161&sprefix=%2Caps%2C171&sr=8-1',
        },
        {
          name: 'GameStop',
          link: 'https://www.gamestop.com/video-games/nintendo-switch/products/farmagia---day-1-edition---nintendo-switch/20014031-6c0948f1.html',
        },
        {
          name: 'Target',
          link: 'https://www.target.com/p/farmagia-day-1-edition-nintendo-switch/-/A-92542496#lnk=sametab',
        },
        {
          name: 'Walmart',
          link: 'https://www.walmart.com/ip/Farmagia-Nintendo-Switch/7007871602?from=/search',
        },
      ],
    },
    steam: {
      digital: {
        digitalDeluxe: 'https://store.steampowered.com/app/2508770/Farmagia/',
        digitalStandard: 'https://store.steampowered.com/app/2508770/Farmagia/',
      },
    },
  },
  ca: {
    ps5: {
      digital: {
        digitalDeluxe: 'https://store.playstation.com/en-us/concept/10009622',
        digitalStandard: 'https://store.playstation.com/en-us/concept/10009622',
      },
      physical: [
        {
          name: 'Marvelous-USA Store',
          link: 'https://www.xseedgames.com/product/farmagia-day-one-edition/',
        },
        {
          name: 'VGP.CA',
          link: 'https://videogamesplus.ca/products/farmagia-day-1-edition-playstation-5-pre-order-free-shipping?_pos=1&_sid=426130919&_ss=r',
        },
        {
          name: 'Amazon',
          link: 'https://www.amazon.ca/Farmagia-Day-1-Edition-PS5/dp/B0D7G2L8CK/ref=sr_1_5?crid=1ZP4UQNXY5LI&dib=eyJ2IjoiMSJ9.xkzfT-H0f0AHIKlU-L_hb8EKn_IwzghgrNDY3cRio-3ZlNXne3T0_GZKHicqZ9KHjgfY4dzUOg4PtHVm4LZAzw.ZlFSHZ5suPbyF6GlJhnj9A3pRgU7YP1eBmdxevrjQIc&dib_tag=se&keywords=farmagia&qid=1723239925&sprefix=farmagi%2Caps%2C161&sr=8-5',
        },
        {
          name: 'GameStop',
          link: 'https://www.gamestop.ca/PS5/Games/923806/farmagia-day-1-edition',
        },
      ],
    },
    switch: {
      digital: {
        digitalStandard:
          'https://www.nintendo.com/en-ca/store/products/farmagia-switch/',
        digitalDeluxe:
          'https://www.nintendo.com/en-ca/store/products/farmagia-digital-deluxe-edition-switch/',
      },
      physical: [
        {
          name: 'Marvelous-USA Store',
          link: 'https://www.xseedgames.com/product/farmagia-day-one-edition/',
        },
        {
          name: 'VGP.CA',
          link: 'https://videogamesplus.ca/products/farmagia-day-1-edition-nintendo-switch-pre-order?_pos=2&_sid=426130919&_ss=r',
        },
        {
          name: 'Amazon.CA',
          link: 'https://www.amazon.ca/Farmagia-Day-1-Nintendo-Switch/dp/B0D7K44TVF/ref=sr_1_1?crid=AGW37R19INTG&dib=eyJ2IjoiMSJ9.EKOTyJ7-HotimK_Wg7EEs8-kX3_6-xKhi8No0Muzxt91dc9TiaZNuCoBQMaKthY0g80CC0lLUISGpnl2JXI5NYnaVq_bbnQSQ6cZ6JPzNwBCR-tLgK_StLFv54aQqg1aLziu4hmwGD81B9VGfqvnM4E752shl6YxPws9-C-rDlx2Ekht2kBr_RZy3CJTCqwcYybN5bqYk2NyJEcoxo4bCGR3oNetXm0GrmtJPf0fR-nw_vQWesAk0LXC4uzyhbikOzrpEtHqh9q5E8n-LTjSRepuohViNzOkLrm5eftO2pU.2f0lJYHvqOkATz98W6WHbPJTe1ECE-SsC_b3kCYotFE&dib_tag=se&keywords=farmagia+game&qid=1719501209&sprefix=%2Caps%2C116&sr=8-1',
        },
        {
          name: 'GameStop (CA)',
          link: 'https://www.gamestop.ca/Switch/Games/923807/farmagia-day-1-edition',
        },
      ],
    },
    steam: {
      digital: {
        digitalDeluxe: 'https://store.steampowered.com/app/2508770/Farmagia/',
        digitalStandard: 'https://store.steampowered.com/app/2508770/Farmagia/',
      },
    },
  },
};

export const comingSoon = {
  en: 'Links Coming Soon',
  ca: 'Links Coming Soon',
  uk: 'Links Coming Soon',
  au: 'Links Coming Soon',
  fr: 'Liens bientôt disponibles',
  it: 'Collegamenti presto disponibili',
  de: 'Links bald verfügbar',
  es: 'Enlaces muy pronto',
  br: 'Links em breve',
  mx: 'Próximamente los enlaces',
};

export const editionsInfo = {
  en: {
    digitalDeluxe: {
      image_640: dde_640,
      image_1280: dde_1280,
      image_640_webp: dde_640_webp,
      image_1280_webp: dde_1280_webp,
      title: '',
      items: [],
    },
    digitalStandard: {
      image_640: logo,
      image_1280: logo,
      image_640_webp: logo,
      image_1280_webp: logo,
      title: '',
      items: [],
    },
    physicalLaunch: {
      image_640: phy_day_one_640,
      image_1280: phy_day_one_1280,
      image_640_webp: phy_day_one_640_webp,
      image_1280_webp: phy_day_one_1280_webp,
      title: '',
      items: [],
    },
  },
  ca: {
    digitalDeluxe: {
      image_640: dde_640,
      image_1280: dde_1280,
      image_640_webp: dde_640_webp,
      image_1280_webp: dde_1280_webp,
      title: '',
      items: [],
    },
    digitalStandard: {
      image_640: logo,
      image_1280: logo,
      image_640_webp: logo,
      image_1280_webp: logo,
      title: '',
      items: [],
    },
    physicalLaunch: {
      image_640: phy_day_one_640,
      image_1280: phy_day_one_1280,
      image_640_webp: phy_day_one_640_webp,
      image_1280_webp: phy_day_one_1280_webp,
      title: '',
      items: [],
    },
  },
};
